import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  CompanyCognismTokenQuery,
  UpdateCompanyCognismTokenMutation,
  UpdateCompanyCognismTokenMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { COMPANY_COGNISM_TOKEN_QUERY_KEY } from "./useCompanyCognismToken";

const updateCompanyCognismToken = graphql(`
  mutation updateCompanyCognismToken($UpdateCognismTokenRequest: UpdateCognismTokenRequest!) {
    updateCompanyCognismToken(UpdateCognismTokenRequest: $UpdateCognismTokenRequest) {
      source
      lastFour
    }
  }
`);

export function useUpdateCompanyCognismToken(
  options?: UseMutationOptions<
    UpdateCompanyCognismTokenMutation,
    ClientError,
    UpdateCompanyCognismTokenMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  return useGraphQlMutation(updateCompanyCognismToken, {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.setQueryData<CompanyCognismTokenQuery>(COMPANY_COGNISM_TOKEN_QUERY_KEY, {
        companyCognismToken: data.updateCompanyCognismToken,
      });
      options?.onSuccess?.(data, variables, context);
    },
  });
}
